import _assert from "./assert";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const assert_1 = __importDefault(_assert);
function assertValidUserOptions(options) {
  assert_1.default(Array.isArray(options.domains), "domains must be an array");
  assert_1.default(Array.isArray(options.topLevelDomains), "topLevelDomains must be an array");
  assert_1.default(Array.isArray(options.secondLevelDomains), "secondLevelDomains must be an array");
  assert_1.default(typeof options.distanceFunction === "function", "distanceFunction must be a function");
}
exports.default = assertValidUserOptions;
export default exports;